import "./Loader.css";
import { Logo } from "./Icons";

export default function LoadingScreen({ isLoading, label = "Loading…" }) {
  if (!isLoading) return null;

  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="loading-screen__card">
        <Logo className="loading-screen__logo" />
        <div className="loading-screen__spinner" aria-hidden />
        <p className="loading-screen__label">{label}</p>
      </div>
    </div>
  );
}